import styles from "./sharedStyle.module.scss";

// MODALS
export const ModalTitle = (props) => {
  const { children } = props;
  return (
    <div className={styles.modal_title}>
      {children}
    </div>
  );
};

export const ModalSubTitle = (props) => {
  const { children } = props;
  return (
    <div className={styles.modal_sub_title}>
      {children}
    </div>
  );
};

export const VehicleSelector = (props) => {
  const { children } = props;
  return (
    <div className={styles.vehicle_selector}>
      {children}
    </div>
  );
};

export const TitleContainer = (props) => {
  const { children, className } = props;
  return (
    <div className={`${styles.title_container} ${className}`}>
      {children}
    </div>
  );
};

// FORM (formsy, html inputs)
export const SubmitInput = (props) => {
  const { style, type, value } = props;
  return (
    <input className={styles.submit_input} style={style} type={type} value={value} />
  );
};

export const LinkContainer = (props) => {
  const { children, className } = props;
  return (
    <div className={`${styles.link_container} ${className}`}>
      {children}
    </div>
  );
};
